<template>
	<m-tab-bar :tabs="tabs" :model-value="active" @update:model-value="onSelect" />
</template>

<script setup>
	import {
		computed,
		onMounted
	} from 'vue'
	import {
		ROLE_LEVELS
	} from '@/common/game/data.js'
	import {
		cache
	} from '@/utils/settingsStore.js'

	const props = defineProps({
		modelValue: {
			type: [String, Number],
			default: ''
		},
		tabs: {
			type: Array,
			default: null
		},
		includeAll: {
			type: Boolean,
			default: true
		},
		allLabel: {
			type: String,
			default: '全部'
		},
		allValue: {
			type: String,
			default: 'all'
		}
	})

	const emit = defineEmits(['update:modelValue', 'change'])

	const active = computed(() => String(props.modelValue == null ? '' : props.modelValue))

	const items = computed(() => {
		const raw = Array.isArray(props.tabs) && props.tabs.length ? props.tabs : ROLE_LEVELS
		return raw.map((t) => {
			if (t && typeof t === 'object' && !Array.isArray(t)) {
				return {
					label: String(t.label == null ? t.value : t.label),
					value: String(t.value)
				}
			}
			return {
				label: String(t) + '级',
				value: String(t)
			}
		})
	})

	const tabs = computed(() => {
		const list = items.value
		return props.includeAll ? [{
			label: props.allLabel,
			value: props.allValue
		}, ...list] : list
	})

	// 未显式指定值时：优先回退到全局设置里保存的人物等级，否则落到「全部」
	function ensureDefault() {
		if (active.value) return
		const settingLevel = cache.value.roleLevel == null ? '' : String(cache.value.roleLevel)
		let def = ''
		if (settingLevel && items.value.some((it) => it.value === settingLevel)) {
			def = settingLevel
		} else if (props.includeAll) {
			def = props.allValue
		}
		if (def && def !== active.value) {
			emit('update:modelValue', def)
			emit('change', def)
		}
	}

	onMounted(ensureDefault)

	function onSelect(val) {
		let next = String(val)
		if (props.includeAll && active.value === next) next = props.allValue
		emit('update:modelValue', next)
		emit('change', next)
	}
</script>
